module.exports = __webpack_public_path__ + "static/media/adept.cbb226e3.jpg";